import { TrashCan, UserFilled } from "@carbon/icons-react"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { useEffect, useState } from "react"
import { ChevronDown } from "react-feather"
import { getAssignedDrones, unAssignedDroneApi } from "../../api/dronesAPI"
import { useAuthStore } from "../../store/authStore"
import { capitalize } from "../../helpers/commonFunction"
import { ToastContainer, toast } from "react-toastify"
import useDroneStore from "../../store/droneStore"
import DeletePilotConfirmationModal from "./pilotModel/pilotConfirmationModel"

const PilotAccordian = ({ name, email, userId }) => {
    const [isOpened, setIsOpened] = useState(false)
    const { token, setLoaderState } = useAuthStore((state) => state)
    const { setShowPilotModal, showPilotModel } = useDroneStore((state) => state);

    const assignedDrones = useQuery([token, userId], () => getAssignedDrones(token, userId), { enabled: isOpened })
    const { mutate, data, error, isSuccess } = useMutation({
        mutationFn: unAssignedDroneApi,
        onSuccess: () => {
            setLoaderState(false)
        }

    })


    // console.log(userId)
    // getAssignedDrones

    const UnAssignDrone = async (data) => {
        // console.log(data)
        setLoaderState(true)
        mutate({ token, data })
    }

    useEffect(() => {
        toast.success(data?.data?.message)
    }, [data?.data])

    return (
        <>
            <ToastContainer />
            {(showPilotModel && name) && <DeletePilotConfirmationModal email={email} name={name} userId={userId} />}
            <div className={`w-4/5 h-14 shadow-sm border ${isOpened ? "rounded-b-none border-b-0 transform" : ""} rounded-xl border-zinc-400 mt-10 flex items-center p-4 justify-between`}>
                <div className="flex space-x-3">
                    <div>
                        <UserFilled style={{ color: "#2e5baa" }} size={24} />
                    </div>
                    <div>
                        <p className="text-lg m-0"><span className="text-tblu font-semibold">Email:</span> {email}</p>
                    </div>
                </div>
                <div>
                    <div className="flex items-center space-x-5">

                        <span>
                            <p className="capitalize text-lg m-0"><span className="text-tblu font-semibold">Name:</span>{name}</p>
                        </span>

                    </div>
                </div>
                <div>
                    <span>
                        <ChevronDown size={24} onClick={() => { setIsOpened(!isOpened) }} className="cursor-pointer" />
                    </span>
                    {/* <TrashCan style={{ color: "red" }} size={24} /> */}
                </div>
                <div>
                    <span>
                        <TrashCan size={20} onClick={() => { setShowPilotModal(true) }} className="cursor-pointer text-red-700" />
                    </span>
                    {/* <TrashCan style={{ color: "red" }} size={24} /> */}
                </div>
            </div>

            {isOpened &&
                <div className={`bg-zinc-100 w-4/5 rounded-lg rounded-t-none grid grid-cols-3 border-zinc-400 border border-t-0 ${isOpened ? 'transition-delay' : ''
                    }`}>
                    {assignedDrones?.data?.data?.data?.map((drone, index) => {
                        // console.log(drone)
                        return (
                            <>
                                <div className="py-2 pl-2">
                                    <ul className="flex items-center">
                                        <li className="capitalize pr-1">{drone.droneId.droneName}</li>
                                        <li className="cursor-pointer" onClick={(e) => { UnAssignDrone({ droneId: drone?.droneId?.droneId, userId: drone.userId }) }}><TrashCan className="text-red-600" key={index} /></li>
                                    </ul>
                                </div>
                            </>
                        )
                    })
                    }

                </div>
            }
        </>
    )
}

export default PilotAccordian